import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import { DefaultTheme } from "styled-components";

interface Props {
  buttonType?: string;
  table?: boolean;
  disabled?: boolean;
}

const DefaultButton = styled.button`
  padding: 6px 20px;
  border-radius: 2px;
  font-size: ${calcRem(16)};
  ${FLEX.FlexCenterCenter};
  gap: 7px;
  cursor: pointer;
  color: ${({ theme }) => theme.COLORS.WHITE} !important;

  &:focus:enabled,
  &:hover:enabled {
    filter: brightness(120%) saturate(120%);
  }
`;

export const Container = styled(DefaultButton)<Props>`
  transition: all ease-out 0.1s;
  ${(props) =>
    props.buttonType === "cancel"
      ? `
      background-color: ${
        props.theme.value === "light" ? COLORS.BUTTONS1 : COLORS.TOGGLE
      };
    `
      : `
        background-color: ${props.theme.COLORS.BUTTONS2};
    `};

  ${(props) =>
    props.buttonType === "warning" &&
    `
      background-color: ${COLORS.RED};
    `};
  ${(props) =>
    props.buttonType === "view" &&
    `
      background-color: ${COLORS.PROGRESSBAR};
    `};
  ${(props) =>
    props.disabled &&
    `
    opacity: 0.25;
  `}
  ${mediaQuery.isMobile} {
    padding: 6px;
  }
`;

export const TinyButton = styled(Container)`
  padding: 4px 6px;
  gap: 3px;

  > span {
    font-size: ${calcRem(12)};
    color: ${COLORS.WHITE};
    font-weight: 500;
    ${FLEX.FlexCenterCenter};
  }
  .tiny-button-icon {
    color: ${COLORS.WHITE};
  }

  .tiny-button-icon > img {
    height: 10px;
  }
`;

export const BigButton = styled(Container)<Props>`
  white-space: nowrap;
  padding: 12px 15px;
  border-radius: 3px;
  font-size: ${calcRem(18)};

  &:focus,
  &:hover:enabled {
    filter: brightness(120%) saturate(120%);
  }
  &:disabled {
    cursor: not-allowed;
  }
  ${mediaQuery.isDefault} {
    min-width: 130px;
  }
  ${mediaQuery.isMobile} {
    min-width: 70px;
    min-width: max-content;
    width: 100%;
  }

  > img,
  > svg {
    width: 14px;
    min-width: 14px;
    height: 14px;
  }

  > svg {
    color: ${COLORS.WHITE};
  }
`;

export const ButtonLabel = styled.span<Props>`
  white-space: pre;
  color: ${COLORS.WHITE};
  font-weight: 500;
  ${FLEX.FlexCenterCenter};
  gap: 3px;
  font-size: ${calcRem(15)};

  ${({ table }) =>
    table &&
    `
      font-size: ${calcRem(14)};
    `}
`;

export const MobileTableButtonIconWrapper = styled.button`
  color: ${({ theme }) => theme.COLORS.WHITE};
`;
